import React from 'react';
import { Link } from 'react-router-dom';
import { projectsData, getCategoryColor } from '../../data/projects';
import './Projects.css';

const ProjectCard = ({ project }) => {
  const categoryColor = getCategoryColor(project.category);
  const isCompleted = project.status === 'Completado';

  return (
    <div className="project-card">
      <Link to={`/proyectos/${project.id}`} className="project-card__image-wrap">
        <img
          src={project.coverImage}
          alt={project.title}
          className="project-card__image"
          loading="lazy"
        />
        <div className="project-card__overlay" />
        <span
          className="project-card__category-badge"
          style={{ background: categoryColor }}
        >
          {project.category}
        </span>
        <span
          className={`project-card__status ${
            isCompleted
              ? 'project-card__status--completed'
              : 'project-card__status--in-process'
          }`}
        >
          {isCompleted ? '✓ Completado' : '◐ En proceso'}
        </span>
      </Link>

      <div className="project-card__body">
        <h3 className="project-card__title">{project.title}</h3>
        <div className="project-card__meta">
          <span className="project-card__meta-item">
            📍 {project.location.split(',')[0]}
          </span>
          {!project.hideTechSheet && (
            <>
              <span className="project-card__meta-dot" />
              <span className="project-card__meta-item">
                📐 {project.area}
              </span>
              <span className="project-card__meta-dot" />
              <span className="project-card__meta-item">
                📅 {project.year}
              </span>
            </>
          )}
        </div>
        <p className="project-card__desc">{project.shortDescription}</p>
      </div>

      <div className="project-card__footer">
        <Link to={`/proyectos/${project.id}`} className="project-card__btn">
          Ver más
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
            <path
              d="M3 8H13M13 8L8 3M13 8L8 13"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>
    </div>
  );
};

const Projects = () => {
  // Show only first 6 on home page
  const featured = projectsData.slice(0, 6);

  return (
    <section id="projects" className="projects-home">
      <div className="container">
        <div className="projects-home__header">
          <div>
            <span className="section-label">Portafolio</span>
            <h2 className="projects-home__heading">
              Proyectos
              <em>destacados.</em>
            </h2>
          </div>
          <Link to="/proyectos" className="btn-see-all">
            Ver todos los proyectos
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
              <path
                d="M3 8H13M13 8L8 3M13 8L8 13"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>

        <div className="projects-home__grid">
          {featured.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>

        <div className="projects-home__footer">
          <Link to="/proyectos" className="btn-primary-lg">
            Ver todos los proyectos
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M3 8H13M13 8L8 3M13 8L8 13"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Projects;
